import { render, staticRenderFns } from "./CalendarEventIconStatus.vue?vue&type=template&id=970ad0a0&"
import script from "./CalendarEventIconStatus.vue?vue&type=script&lang=js&"
export * from "./CalendarEventIconStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports